export default "__VITE_ASSET__DwDWfgRg__"